import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { AlertTriangle } from "lucide-react";

export function ReportMismatchModal({
  open,
  onOpenChange,
  child,
  form,
  setForm,
  loading,
  onSubmit
}) {
  const board = (child?.board || "cbse") === "ib" ? "IB" : "CBSE";
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="report-mismatch-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            Report a Content Mismatch
          </DialogTitle>
          <DialogDescription>
            Spotted something that doesn&apos;t match the <strong>{board}</strong> syllabus for{" "}
            {child?.name || "your child"} (Grade {child?.grade})? Tell us and our content team will review and improve it.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <label className="text-sm font-medium">Subject (optional)</label>
            <Input
              data-testid="report-mismatch-subject"
              value={form.subject}
              onChange={(e) => setForm({ ...form, subject: e.target.value })}
              placeholder="e.g. Mathematics"
            />
          </div>
          <div>
            <label className="text-sm font-medium">Topic (optional)</label>
            <Input
              data-testid="report-mismatch-topic"
              value={form.topic}
              onChange={(e) => setForm({ ...form, topic: e.target.value })}
              placeholder="e.g. Fractions"
            />
          </div>
          <div>
            <label className="text-sm font-medium">What&apos;s the mismatch? *</label>
            <Textarea
              data-testid="report-mismatch-description"
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
              placeholder="Describe what looked off compared to the official syllabus..."
              rows={4}
            />
          </div>
          <Button
            data-testid="report-mismatch-submit"
            onClick={onSubmit}
            disabled={loading || !form.description.trim()}
            className="w-full"
          >
            {loading ? "Submitting..." : "Submit Report"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
